<div class="progressContainer" *ngIf="progressBar()">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="layout-container" [ngClass]="containerClass">
  <kanzi-ui-top-bar
    wereHouseListHide
    (selectLanguage)="changeLanguage($event)"
  ></kanzi-ui-top-bar>
  <kanzi-ui-main-sidebar
    [mainMenuItems]="itemsMenu()"
    [userProfile]="userProfile()"
    (onLogout)="logoutSession()"
  ></kanzi-ui-main-sidebar>
  <div class="layout-content-wrapper">
    <kanzi-ui-breadcrumb id="breadcrumbStep"></kanzi-ui-breadcrumb>
    <div class="layout-content" id="contentStep">
      @if (sessionReady()) {
      <router-outlet></router-outlet>
      }
    </div>
  </div>
</div>
